module.exports = __webpack_public_path__ + "img/taiwanmobile-logo.d8b48e50.png";